import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { EventProvider } from './context/EventContext';
import { HomeView } from './views/HomeView';
import { LeaderboardView } from './views/LeaderboardView';
import { TopicView } from './views/TopicView';
import { PresenterView } from './views/PresenterView';

export default function App() {
  return (
    <BrowserRouter>
      <EventProvider>
        <AppShell>
          <Routes>
            <Route path="/" element={<HomeView />} />
            <Route path="/topics/:topicId" element={<TopicView />} />
            <Route path="/leaderboard" element={<LeaderboardView />} />
            <Route path="/presenter" element={<PresenterView />} />
            <Route path="*" element={<HomeView />} />
          </Routes>
        </AppShell>
      </EventProvider>
    </BrowserRouter>
  );
}
